import React from 'react';
import { ClassBuilder } from 'b302-frontend-library';
import { ReactComponent as IconLoading } from '../../assets/icons/icon_loading.svg';

interface IProps {
    /**
     * @name modifiers
     * @description possible modifiers are:
     * - white
     * - han-red
     * 
     * The default color is black; 
     */
    modifiers?: string[]
}

const LoadingIcon: React.FC<IProps> = ({ modifiers }) => {
    const baseClassName = "loading-icon";

    const classBuilder = ClassBuilder.createClass(baseClassName);

    modifiers?.forEach(modifier => {
        classBuilder.add(`${baseClassName}--${modifier}`)
    });

    return (
        <IconLoading className={classBuilder.build()} />
    )
}

export default LoadingIcon;
